// extracted by mini-css-extract-plugin
export default {"root":"styles_root__GuiGc","new":"styles_new__GbPRY"};